// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4XU5g","top":"styles_top__4Oz-m"};